import { useEffect, useState } from 'react';
import { BsThreeDots } from "react-icons/bs";
import { ImNewTab } from "react-icons/im";
import { TbGalaxy } from "react-icons/tb";
import Markdown from "../Markdown/Markdown";
import ThreedotsLoading from '../Loaders/ThreedotsLoading';
import ErrorMessage from '../Components/ErrorMessage';
import { LuFile, LuFileText, LuImage, LuPen, LuVideo } from 'react-icons/lu';
import { BiCopy, BiDownload, BiPen } from 'react-icons/bi';
import Spinner from '../Components/Spinner';
import { CiCircleAlert, CiCircleCheck } from 'react-icons/ci';
import { MdCheck, MdOutlineCopyAll } from 'react-icons/md';
import { useLanguage } from '../Translations/LenguageContext';

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const ChatMessages = ({
    account_id,
    msg,
    isSearchEnabled,
    openReasoning,
    onToggleReasoning,
    chatEndRef,
    userLastMessageRef,
    handleScroll,
    errorAi,
    steps,
    activeAiMessageId,

    openWebPreview,
    setOpenWebPreview,
    selectedLink,
    setSelectedLink,
    isLoading,
    updateNewMessage
}) => {
    const {t} = useLanguage()
    const isAi = msg.sender === "ai";
    const isUser = msg.sender === "user";

    const [copied, setCopied] = useState(false);
    const [isChangingUserMex, setIsChangingUserMex] = useState(false)
    const [messageToChangeId, setMessageToChangeId] = useState(null)
    const [messageToChange, setMessageToChange] = useState("")

    const [showAllLinks, setShowAllLinks] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false)
    const [fileToDownload, setFileToDownload] = useState(null)

    const results = msg.search_metadata?.results || [];
    const initialLimit = 5;
    const visibleResults = showAllLinks ? results : results.slice(0, initialLimit);
    const hasMore = results.length > initialLimit;

    const getFileIcon = (name) => {
        if (!name) return <LuFile />;

        const ext = name.split(".").pop().toLowerCase();

        if (["mp4", "mov", "avi", "mkv", "webm"].includes(ext)) {
            return <LuVideo />;
        }

        if (["png", "jpg", "jpeg", "gif", "svg", "webp", "bmp"].includes(ext)) {
            return <LuImage />;
        }

        if (ext === "pdf") {
            return <LuFileText />;
        }

        return <LuFile />;
    };

    // useEffect(() => {
    //     // if (chatEndRef?.current) {
    //     //     chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    //     // }
    //     // if (userLastMessageRef?.current){
    //     //     userLastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    //     // }


    // }, [userLastMessageRef, steps]);

    const [autoScroll, setAutoScroll] = useState(true);

    useEffect(() => {
        const handleUserScroll = () => {
            setAutoScroll(false);
        };

        window.addEventListener("wheel", handleUserScroll);
        window.addEventListener("touchmove", handleUserScroll);

        return () => {
            window.removeEventListener("wheel", handleUserScroll);
            window.removeEventListener("touchmove", handleUserScroll);
        };
    }, []);

    useEffect(() => {
        if (isUser && autoScroll && userLastMessageRef.current) {
            userLastMessageRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }, [msg]);


    const downloadItem = async (item) => {
        setLoadingDownload(true)
        setFileToDownload(item.id)
        try {
            const res = await fetch(`${GEN_BACKEND_LINK}/get_file_download_url`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id: account_id,
                    file_id: item.id,
                }),
            });

            const data = await res.json();

            if (data.error == "file_not_found") {
                console.log("Not found");
            }

            if (!res.ok) throw new Error(data.error);

            window.open(data.url, "_blank");

        } catch (err) {
            setLoadingDownload(false)
            console.error("Download error:", err);
        } finally {
            setLoadingDownload(false)
        }
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(msg.text);
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
        } catch (err) {
            console.error("Copy failed:", err);
        }
    };

    const handleChangeUserMex = (msg) => {
        setIsChangingUserMex(true)
        setMessageToChangeId(msg.id)
        setMessageToChange(msg.text)
    }

    const autoResize = (e) => {
        e.target.style.height = "auto";
        e.target.style.height = `${e.target.scrollHeight}px`;
    };

    const handleCancel = () => {
        setIsChangingUserMex(false)
        setMessageToChangeId(null)
        setMessageToChange("")
    }

    return (
        <div className={`message_wrapper fade-in ${isAi ? "ai_wrapper" : "user_wrapper"}`} ref={isUser ? userLastMessageRef : null}>
            <div className={`message_bubble ${isAi ? "ai_bubble" : "user_bubble"}`} >
                <div className="message_header">
                    <span className="message_sender_label fade-in">
                        {isAi ? msg.model_used : "User"}
                    </span>
                    <i className='fade-in'><TbGalaxy /></i>
                    <span className="timestamp_message fade-in">{msg.timestamp}</span>
                </div>

                {isAi && msg.reasoning_flow?.length > 0 && (
                    <div className="reasoning_cont fade-in">
                        <p className="reasoning_cont_title">
                            {(msg.reasoning_depth || "")
                                .charAt(0)
                                .toUpperCase() + (msg.reasoning_depth || "").slice(1)} {t.reasoning}
                            <button className="reasoning_cont_btn" onClick={onToggleReasoning}>
                                <i className={`fa-solid fa-chevron-${openReasoning ? "up" : "down"}`}></i>
                            </button>
                        </p>
                        <div className={`reasoning_item_cont ${openReasoning ? "reasoning_item_cont_open" : ""}`}>
                            {msg.reasoning_flow.map((res, idx) => (
                                <div className="reasoning_item" key={idx}>
                                    <p className="reasoning_item_intent">{res.step}. {res.reasoning_intent}</p>
                                    <p className="reasoning_item_content">{res.reasoning}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {isAi && !msg.text && isLoading && msg.id == activeAiMessageId ? (
                    <div className='loading_mex_chat_cont fade-in'>
                        {msg.live_message ? (
                            <div className='fade-in'>
                                <p className='loading_mex_chat_cont_p'>
                                    <Spinner loading={true} /> {msg.live_message}
                                </p>
                            </div>
                        ) : (
                            <ThreedotsLoading />
                        )}
                    </div>
                ) : (
                    isChangingUserMex && msg.id == messageToChangeId ? (
                        <div className='update_mex_bubble fade-in'>
                            <textarea
                                value={messageToChange}
                                onChange={(e) => {
                                    setMessageToChange(e.target.value);
                                    autoResize(e)
                                }}
                                className='update_mex_bubble_input'
                            />
                            <div className='update_mex_bubble_input_btn_cont'>
                                <button className='modale_save_btn fade-in' onClick={(e)=> updateNewMessage(e, messageToChangeId, messageToChange)}>{t.send}</button>
                                <button className='modale_close_btn fade-in' onClick={handleCancel}>{t.cancel}</button>
                            </div>
                        </div>
                    ) : (
                        <Markdown
                            msg={msg.text}
                            chatEndRef={chatEndRef}
                            userLastMessageRef={userLastMessageRef}
                            sources={results}
                        />
                    )
                )}


                {isUser && msg.files.length > 0 && (
                    <div className="attachment_item_cont">
                        {msg.files.map((file, i) => (
                            <div key={i} className="attachment_item fade-in">
                                {getFileIcon(file.name)}
                                <div className="attachment_item_name" title={file.name}>
                                    {file.name}
                                </div>
                                {file.id && (
                                    <button
                                        className="download_file_btn"
                                        onClick={() => downloadItem(file)}
                                        title="Download file"
                                        disabled={loadingDownload}
                                    >
                                        {loadingDownload && fileToDownload == file.id ? (
                                            <Spinner loading={true} />
                                        ) : (
                                            <BiDownload />
                                        )}
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                {isAi && msg.generated_files?.length > 0 && (
                    <div className="attachment_item_cont">
                        {msg.generated_files.map((file, i) => (
                            <div key={i} className="attachment_item fade-in">
                                {getFileIcon(file.name)}
                                <div className="attachment_item_name" title={file.name}>
                                    {file.name}
                                </div>
                                <button
                                    className="download_file_btn"
                                    onClick={() => downloadItem(file)}
                                    title="Download file"
                                    disabled={loadingDownload}
                                >
                                    {loadingDownload && fileToDownload == file.id ? (
                                        <Spinner loading={true} />
                                    ) : (
                                        <BiDownload />
                                    )}
                                </button>
                            </div>
                        ))}
                    </div>
                )}

                {msg.text && (
                    <div className='footer_message_bubble'>
                        <button
                            className="footer_message_bubble_btn"
                            onClick={handleCopy}
                        >
                            {copied ? (
                                <i className='fade-in'>
                                    <MdCheck />
                                </i>
                            ) : (
                                <i className='fade-in'>
                                    <MdOutlineCopyAll />
                                </i>
                            )}
                        </button>
                        {/* {isUser && (
                            <button className='footer_message_bubble_btn' onClick={() => handleChangeUserMex(msg)}><LuPen /></button>
                        )} */}
                    </div>
                )}

                {steps && isAi && msg.id == activeAiMessageId &&
                    Object.keys(steps).length > 0 && (
                        <div className="steps_cont fade-in" chatEndRef={chatEndRef} >
                            {Object.entries(steps).map(([stepId, step]) => (
                                <div className="steps_item fade-in " key={stepId} >

                                    <i>
                                        {step.status === "LOADING" && <Spinner loading={true} />}
                                        {step.status === "SUCCESS" && <CiCircleCheck />}
                                        {step.status === "ERROR" && <CiCircleAlert />}
                                    </i>

                                    {stepId.startsWith("params") ? (
                                        <div className="code_params_steps" dangerouslySetInnerHTML={{ __html: step.title }} />
                                    ) : (
                                        <p>{step.title}</p>
                                    )}

                                </div>
                            ))}

                        </div>
                    )}

                {errorAi && msg.id == activeAiMessageId && (
                    <ErrorMessage err={errorAi} />
                )}


                {isAi && results.length > 0 && (
                    <div className="search_results_cont fade-in">
                        <p className="search_results_title">
                            {results.length} {t.playground.search_results}
                        </p>
                        <div className="search_results">
                            {visibleResults.map((result, idx) => (
                                // <div key={idx} className="source_item" onClick={() => window.open(result.link, "_blank")}>
                                <div key={idx} className="source_item" onClick={() => { setSelectedLink(result.link); setOpenWebPreview(true) }}>
                                    <p className="source_title">{result.title}</p>
                                    <p className="source_snippet">{result.snippet}</p>
                                    <div className="open_resource_source">
                                        <div className="open_resource_source_inner">
                                            <span>{t.playground.open_resource} <i><ImNewTab /></i></span>
                                            <span className="open_resource_link" >{result.link}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* Toggle Button */}
                            {hasMore && (
                                <div
                                    className="more_sources_btn_cont"
                                    onClick={() => setShowAllLinks(!showAllLinks)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <button className='more_sources_btn'>
                                        {showAllLinks
                                            ? <i className='fa-solid fa-chevron-left'></i>
                                            : `+ ${results.length - initialLimit}`
                                        }
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ChatMessages;